module.exports = __webpack_public_path__ + "img/bread-carousel.4233e6bd.jpg";